import { render } from "./package-dialog.vue?vue&type=template&id=74cd47c5&scoped=true"
import script from "./package-dialog.vue?vue&type=script&lang=js"
export * from "./package-dialog.vue?vue&type=script&lang=js"

import "./package-dialog.vue?vue&type=style&index=0&id=74cd47c5&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-74cd47c5"

export default script